import React from "react";

export const GUTTER_ARROW_CLASS = "flex items-center justify-center px-2 my-1 rounded text-gray-500 cursor-pointer transition-colors hover:bg-gray-300 hover:text-gray-800 disabled:opacity-30 disabled:cursor-default disabled:hover:bg-transparent disabled:hover:text-gray-500";

interface GutterButtonProps {
    icon: React.ReactNode;
    label: string;
    onClick: () => void;
    disabled?: boolean;
    className?: string;
}

const GutterButton = (
    {
        icon,
        label,
        onClick,
        disabled = false,
        className = "",
    }: GutterButtonProps) => {
    return (
        <button
            type="button"
            disabled={disabled}
            onClick={(e) => {
                e.stopPropagation();
                onClick();
            }}
            title={label}
            aria-label={label}
            tabIndex={-1}
            className={`${GUTTER_ARROW_CLASS} ${className}`}
        >
            {icon}
        </button>
    );
};

export default GutterButton;
